const torefarmMainPeople = () => {

  const pageTorefarm = document.getElementById('pageTorefarm');
  if (pageTorefarm) {

    let secMain = document.getElementById('jsSecMain');
    let jsPeople = secMain.querySelectorAll('.js-people-box');

    
    console.log(jsPeople);


    const moveStart = (elem) => {
      let i = elem.querySelector('i');
      i.className = 'act'
    }
    const moveStop = (elem) => {
      let i = elem.querySelector('i');
      i.classList.add('stop');
    }
    const moveReset = (elem) => {
      elem.classList.remove('act')
      let i = elem.querySelector('i');
      setTimeout(() => {
        i.classList.remove('act')
      }, 1000)
    }

    const moveLoop = (elem, time, func) => {
      let diff = 3000
      elem.classList.add('act')
      moveStart(elem)

      if(time !== 0){
        setTimeout(() => {
          moveStop(elem)
        }, time)
        setTimeout(() => {
          moveReset(elem)
        }, time + diff)
        setTimeout(() => {
          func()
        }, time + diff * 2)
      }
    }

    
    const people2 = () => {
      let elem = jsPeople[2]
      let time = 0
      moveLoop(elem, time, people2)
    }
    people2()

    const people4 = () => {
      let elem = jsPeople[4]
      let time = 43200
      moveLoop(elem, time, people4)
    }
    people4()

    const people7 = () => {
      let elem = jsPeople[7]
      let time = 43200
      moveLoop(elem, time, people7)
    }
    people7()

    const people8 = () => {
      let elem = jsPeople[8]
      let time = 43200
      moveLoop(elem, time, people8)
    }
    people8()

    const people9 = () => {
      let elem = jsPeople[9]
      let time = 0
      moveLoop(elem, time, people9)
    }
    people9()

    const people11 = () => {
      let elem = jsPeople[11]
      let time = 0
      moveLoop(elem, time, people11)
    }
    people11()

    const people12 = () => {
      let elem = jsPeople[12]
      let time = 81000
      moveLoop(elem, time, people12)
    }
    people12()


  }

}
export default torefarmMainPeople;